import Vue from 'vue'
import Vuex from 'vuex'
import { isUndefined } from '@/utils'

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.ts$/)
const modules = requireContext.keys()
  .map((file: string) => [
    file.replace(/(^.\/)|(\.ts$)/g, ''),
    requireContext(file)
  ])
  .reduce((modules: any, [name, module]) => {
    if (isUndefined(module.namespaced)) module.namespaced = true
    return {
      ...modules,
      [name]: module
    }
  }, {})
  
export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production'
})